import apiClient from "./api";

const ppaIntegrationService = {
  async getHealth() {
    const response = await apiClient.get("/ppa-integration/health");
    return response.data;
  },

  async readOpportunity(opportunityId) {
    const response = await apiClient.post(
      `/ppa-integration/opportunities/${opportunityId}/read`,
      { contractVersion: "ppa-integration-1" }
    );
    return response.data;
  },

  async readDocumentIntelligence(opportunityId) {
    const response = await apiClient.post(
      `/ppa-integration/opportunities/${opportunityId}/document-intelligence`,
      { contractVersion: "ppa-document-intelligence-1" }
    );
    return response.data;
  },

  async proposePursuit(opportunityId, action = "track") {
    const response = await apiClient.post(
      `/ppa-integration/opportunities/${opportunityId}/pursuit-proposal`,
      { contractVersion: "ppa-integration-1", action }
    );
    return response.data;
  },
};

export const safePPAErrorMessage = (error) => {
  const detail = error?.response?.data?.detail;
  if (detail?.code === "not_enabled") return "PPA intelligence is not enabled for this environment.";
  if (detail?.code === "not_found") return "PPA intelligence is not available for this opportunity.";
  return "PPA intelligence is temporarily unavailable.";
};

export default ppaIntegrationService;
